import classNames from 'classnames';
import type { CSSProperties, FC } from 'react';
import { FileIcon } from './FileIcon';
import styles from './Icon.module.css';
import { type AllIconNames, getIconAttributes, getPath, iconExists } from './icons';

export const Icon: FC<{
  name: AllIconNames;
  className?: string;
  inline?: boolean;
  alt?: string;
  pathStyle?: CSSProperties;
  size?: CSSProperties['width'];
  style?: 'infoIcon';
}> = (props) => {
  if (!iconExists(props.name)) {
    const _name = props.name as FileIcons;
    return <FileIcon {...props} name={_name} />;
  }

  const attr = getIconAttributes(props.name);
  const size = props.size ?? attr?.size ?? '20px';
  const pathStyle = Object.assign({}, attr?.style, props.pathStyle);
  return (
    <span className={classNames(props.className, { [styles.infoIcon]: props.style === 'infoIcon' })}>
      <svg width={size} height={size} viewBox={attr?.viewBox ?? '0 0 1024 1024'} className="icon inner">
        <title>{props.alt || props.name}</title>
        <path style={pathStyle} d={getPath(props.name)}></path>
      </svg>
    </span>
  );
};
